// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #fdf9f5; */
  padding: 10px;
}

.tab {
  padding: 5px 15px;
  margin: 0 10px; /* Adds space between tabs */
  border: none;
  border-radius: 15px;
  background-color: transparent;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.active-tab {
  background-color: orange;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/css/Tabss.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,4BAA4B;EAC5C,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd","sourcesContent":[".tab-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background-color: #fdf9f5; */\n  padding: 10px;\n}\n\n.tab {\n  padding: 5px 15px;\n  margin: 0 10px; /* Adds space between tabs */\n  border: none;\n  border-radius: 15px;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.active-tab {\n  background-color: orange;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
